module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'pg7lo4gf',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
